"use strict";
exports.__esModule = true;
exports.chart_color_black_200 = {
  "name": "--pf-v5-chart-color-black-200",
  "value": "#d2d2d2",
  "var": "var(--pf-v5-chart-color-black-200, #d2d2d2)"
};
exports["default"] = exports.chart_color_black_200;